import React, {useState, useCallback} from 'react';
import DataTable from '@preflighttech/preflight-tables';
import { View, Text, Pressable } from 'react-native';
import {
  USERS_WITH_COUNT,
  HIDE_USER,
  UNHIDE_USER,
  REINVITE_USER
} from './queries';
import { useMutation } from '@apollo/client';
import SubNav from './SubNav';
import {
  MainContainer,
  ContentContainer,
  LinkContainer,
} from '../../../elements';
import Modal from '../../../elements/Modal';
import EditUser from './edit';
const ROLES = ['All', 'Lot', 'Accounting', 'Admin'];
import Filter from 'app/src/elements/Filter';
import { ResetSettings } from 'app/src/elements/Pagination/ResetSettings';

const inputStyle = {
  marginBottom: '10px'
}

const AuctionUsers = () => {
  const [refetch, setRefetch] = useState();
  const [clickedUser, setClickedUser] = useState();
  const [showEditUserModal, setShowEditUserModal] = useState(false);
  const [filterOptions, setFilterOptions] = useState();
  const [filters, setFilters] = useState({});
  const [settings, setSettings] = useState({});
  const queryVariables = {
    filterColumns: [],
    filterNames: [],
    scopes: [],
  };

  const [hideUser] = useMutation(
    HIDE_USER, { onCompleted: refetch }
  )

  const [unHideUser] = useMutation(
    UNHIDE_USER, { onCompleted: refetch }
  )

  const onToggleHide = (userId, isHidden) => {
    if(isHidden) {
      unHideUser({ variables: { id: userId }});
    }else {
      hideUser({ variables: { id: userId }});
    }
  };

  const [resendUserInvite] = useMutation(
    REINVITE_USER, { onCompleted: refetch }
  )

  const onResendInvite = (userId) => {
    resendUserInvite({ variables: { id: userId }});
  };

  const setFilter = (key, value) => {
    const currentFilters = {...filters};
    currentFilters[key] = value;
    setFilters(currentFilters);
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value) {
      queryVariables.filterColumns.push(key);
      queryVariables.filterNames.push(value);
    }
  });

  const columns = [
    {
      key: 'email',
      label: 'Email',
      sort: 'asc',
      // width: '45%',
      content: (entry) => {
        return entry.entry.email
      }
    },
    {
      key: 'firstName',
      label: 'First Name',
      // width: '20%',
      content: (entry) => {
        return entry.entry.firstName
      }
    },
    {
      key: 'lastName',
      label: 'Last Name',
      // width: '20%',
      content: (entry) => {
        return entry.entry.lastName
      }
    },
    {
      key: 'phoneNumber',
      label: 'Phone Number',
      value: ({ value }) => value?.formatted,
    },
    {
      key: 'role',
      label: 'Role',
      // width: '20%',
      content: (entry) => entry.entry.role
    },
    {
      key: 'isHidden',
      label: 'Status',
      // width: '20%',
      sort: 'prevent',
      content: (entry) => entry.entry.isHidden ? 'Inactive' : 'Active'
    },
    {
      key: 'functions',
      label: 'Functions',
      // width: '15%',
      // minViewportWidth: 1000,
      sort: 'prevent',
      content: (entry) => {
        return (
          <View style={{display: 'inline-flex'}}>
            <LinkContainer>

              <Pressable
                onPress={() => {
                  setClickedUser(entry.entry);
                  setShowEditUserModal(true)
                }}
                style={{marginLeft: '10px'}}
                key={`user-edit-link-${entry.entry.id}`}
                  name={`user-edit-link-${entry.entry.id}`}
              >
                <Text>
                  edit
                </Text>
              </Pressable>
              <Text>{` | `}</Text>
              <Pressable
                onPress={() => {
                  if(window.confirm(
                    `Make ${entry.entry.firstName} ${entry.entry.lastName} ${entry.entry.isHidden ? 'active' : 'inactive'}?`,
                  )){
                    onToggleHide(entry.entry.id, entry.entry.isHidden)
                  }
                }}
                key={`user-hide-link-${entry.entry.id}`}
                  name={`user-hide-link-${entry.entry.id}`}
              >
                <Text>
                  {
                    `make ${entry.entry.isHidden ? 'active' : 'inactive'}`
                  }
                </Text>
              </Pressable>
              <Text>{` | `}</Text>
              <Pressable
                onPress={() => {
                  if(window.confirm(
                    entry.entry.invitationAcceptedAt ?
                      `Send password reset to ${entry.entry.email}?` :
                      `Resend account invite to ${entry.entry.email}?`
                  )) {
                    onResendInvite(entry.entry.id)
                  }
                }}
                key={`user-invite-link-${entry.entry.id}`}
                name={`user-invite-link-${entry.entry.id}`}
              >
                <Text>
                  {entry.entry.invitationAcceptedAt ?
                    'send password reset' : 'resend invite'
                  }
                </Text>
              </Pressable>
            </LinkContainer>
          </View>
        )
      }
    }
  ]

  const buttons = (
    <View style={{display: 'flex', flexDirection: 'row'}}>
      <Filter
        clearFilters={() => {
          setFilters({})
          setShowModal(false)
        }}
        filters={filters}
        setFilters={setFilters}
      >
        <View style={{padding: '20px', justifyContent: 'space-between'}}>
          <Text>Show Inactive?</Text>
          <input
            type={'checkbox'}
            name={'showHidden'}
            onChange={e => {
              setFilter('showHidden', e.target.checked)
            }}
            checked={filters.showHidden || false}
            style={{
              marginTop: '-14px',
              marginLeft: '-80px',
              zIndex: 1000,
              ...inputStyle
            }}
          />
          <Text>First Name:</Text>
          <input
            type={'text'}
            name="firstName"
            onChange={e => setFilter('firstName', e.target.value)}
            value={filters.firstName || ''}
            style={inputStyle}
          />
          <Text>Last Name:</Text>
          <input
            type={'text'}
            name="lastName"
            onChange={e => setFilter('lastName', e.target.value)}
            value={filters.lastName || ''}
            style={inputStyle}
          />
          <Text>Role:</Text>
          <select
            type={'select'}
            name="role"
            onChange={e => setFilter('role', e.target.value)}
            value={filters.role || ''}
          >
            {ROLES.map(role => <option key={`role-${role}`}>{role}</option>)}
          </select>
        </View>
      </Filter>
      <ResetSettings />
    </View>
  );

  return (
    <MainContainer>
      <SubNav
        refetch={refetch}
        modalType={'Add User'}
      />
      <ContentContainer>
        <DataTable.Gql
          setRefetch={setRefetch}
          query={USERS_WITH_COUNT}
          queryName='usersWithCount'
          columns={columns}
          pageLength={25}
          buttons={buttons}
          lengthMenu={ [10, 25, 50, 'All'] }
          setSettings={setSettings}
          dataUpdated={data => setFilterOptions(data?.assetsWithCount)}
          htmlTable
          queryVariables={queryVariables}
        />
      </ContentContainer>
      {showEditUserModal &&
        <Modal
          showModal={showEditUserModal}
          setShowModal={setShowEditUserModal}
          modalType={'Edit User'}
          objectName={`${clickedUser.firstName} ${clickedUser.lastName}`}
          user={clickedUser}
        >
          <EditUser
            setShowModal={setShowEditUserModal}
            refetch={refetch}
            user={clickedUser}
          />
        </Modal>
      }
    </MainContainer>
  )
}

export default AuctionUsers;
